export const siteNav = [
  { label: '首页', href: '/' },
  { label: '分类浏览', href: '/category/all' },
  { label: '关于我们', href: '/about' },
];

export const categories = [
  { slug: 'all', name: '全部分类', icon: 'ri-global-line', count: 156 },
  { slug: 'entertainment', name: '娱乐影音', icon: 'ri-movie-2-line', count: 42 },
  { slug: 'shopping', name: '在线购物', icon: 'ri-shopping-bag-3-line', count: 38 },
  { slug: 'lifestyle', name: '生活服务', icon: 'ri-heart-pulse-line', count: 29 },
  { slug: 'tech', name: '科技数码', icon: 'ri-smartphone-line', count: 25 },
  { slug: 'travel', name: '旅游出行', icon: 'ri-plane-line', count: 22 },
];

export const services = [
  {
    id: 's1',
    icon: 'ri-shopping-cart-2-line',
    title: '在线购物',
    description: '汇聚亚洲各地优质商品，足不出户畅享购物乐趣，支持多种支付方式，安全便捷。',
    href: '/category/shopping',
  },
  {
    id: 's2',
    icon: 'ri-film-line',
    title: '娱乐影音',
    description: '最新电影、热门剧集、流行音乐，覆盖亚洲各国精彩娱乐内容，随时随地畅享视听盛宴。',
    href: '/category/entertainment',
  },
  {
    id: 's3',
    icon: 'ri-plane-line',
    title: '旅游出行',
    description: '亚洲热门旅游目的地推荐、攻略分享、优惠预订，让您的每一次出行都充满惊喜。',
    href: '/category/travel',
  },
  {
    id: 's4',
    icon: 'ri-smartphone-line',
    title: '科技数码',
    description: '最新科技产品评测、数码资讯、智能设备推荐，紧跟亚洲科技发展前沿。',
    href: '/category/tech',
  },
  {
    id: 's5',
    icon: 'ri-heart-pulse-line',
    title: '生活服务',
    description: '美食推荐、健康养生、家居生活，覆盖日常生活方方面面，提升品质生活体验。',
    href: '/category/lifestyle',
  },
  {
    id: 's6',
    icon: 'ri-global-line',
    title: '跨境资源',
    description: '连接亚洲各国的优质资源，语言翻译、跨境物流、文化资讯一站式获取。',
    href: '/category/all',
  },
];

export const featuredArticles = [
  {
    id: 'a1',
    title: '2026年亚洲电商市场趋势分析：跨境电商迎来新机遇',
    excerpt: '随着亚洲各国数字经济快速发展，跨境电商市场呈现爆发式增长。本文将深入分析2026年亚洲电商市场的最新趋势与机遇...',
    category: 'shopping',
    categoryName: '在线购物',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Asian%20ecommerce%20warehouse%20with%20packages%20and%20digital%20screens%20showing%20data%20analytics%2C%20warm%20ambient%20lighting%2C%20clean%20minimalist%20style%2C%20professional%20product%20photography%20with%20soft%20shadows&width=800&height=500&seq=article-shopping-01&orientation=landscape',
    author: '李明',
    date: '2026-08-10',
    views: 12580,
    content: '',
  },
  {
    id: 'a2',
    title: '东京奥运会场馆变身：探访日本最新文旅融合项目',
    excerpt: '东京多个奥运场馆经过改造后重新向公众开放，融合文化、旅游、商业等多元功能，成为亚洲文旅融合的新标杆...',
    category: 'travel',
    categoryName: '旅游出行',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Tokyo%20stadium%20architecture%20with%20visitors%20enjoying%20cultural%20exhibitions%2C%20warm%20sunset%20lighting%2C%20clean%20minimalist%20composition%2C%20editorial%20travel%20photography%20with%20natural%20tones&width=800&height=500&seq=article-travel-02&orientation=landscape',
    author: '王芳',
    date: '2026-08-09',
    views: 9876,
    content: '',
  },
  {
    id: 'a3',
    title: '东南亚数字支付革命：无现金社会离我们还有多远？',
    excerpt: '从新加坡到印尼，东南亚各国正加速推进数字支付基础设施建设。移动支付、电子钱包等创新支付方式正在改变数亿人的消费习惯...',
    category: 'tech',
    categoryName: '科技数码',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20showing%20digital%20payment%20app%20interface%20in%20modern%20Asian%20city%20setting%2C%20warm%20golden%20lighting%2C%20clean%20minimalist%20style%2C%20professional%20technology%20photography&width=800&height=500&seq=article-tech-03&orientation=landscape',
    author: '陈伟',
    date: '2026-08-08',
    views: 15632,
    content: '',
  },
  {
    id: 'a4',
    title: '韩国K-POP产业全球化：从亚洲走向世界的文化现象',
    excerpt: '韩国流行音乐产业在过去十年实现了令人瞩目的全球化扩张，不仅创造了巨大的经济效益，更成为亚洲文化输出的标志性力量...',
    category: 'entertainment',
    categoryName: '娱乐影音',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20concert%20stage%20with%20dynamic%20lighting%20and%20energetic%20atmosphere%2C%20Korean%20pop%20culture%20theme%2C%20warm%20vibrant%20colors%2C%20editorial%20music%20photography%20with%20dramatic%20composition&width=800&height=500&seq=article-entertainment-04&orientation=landscape',
    author: '张雪',
    date: '2026-08-07',
    views: 23456,
    content: '',
  },
  {
    id: 'a5',
    title: '亚洲美食地图：2026年必打卡的十家米其林餐厅',
    excerpt: '从东京到曼谷，从上海到新加坡，亚洲拥有全球最密集的米其林星级餐厅。我们精选了2026年最值得专程前往的十家餐厅...',
    category: 'lifestyle',
    categoryName: '生活服务',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Asian%20fine%20dining%20restaurant%20interior%20with%20beautiful%20plated%20dishes%2C%20warm%20ambient%20candlelight%2C%20sophisticated%20minimalist%20style%2C%20professional%20food%20photography&width=800&height=500&seq=article-lifestyle-05&orientation=landscape',
    author: '刘洋',
    date: '2026-08-06',
    views: 18920,
    content: '',
  },
  {
    id: 'a6',
    title: '亚洲可再生能源发展报告：绿色转型中的机遇与挑战',
    excerpt: '亚洲各国在可再生能源领域持续加大投入，太阳能、风能等清洁能源装机容量屡创新高，绿色转型正在重塑亚洲能源格局...',
    category: 'tech',
    categoryName: '科技数码',
    image: 'https://readdy.ai/api/search-image?query=Modern%20solar%20panel%20farm%20with%20wind%20turbines%20in%20beautiful%20Asian%20landscape%2C%20warm%20sunset%20golden%20light%2C%20clean%20minimalist%20composition%2C%20professional%20environmental%20photography&width=800&height=500&seq=article-tech-06&orientation=landscape',
    author: '赵敏',
    date: '2026-08-05',
    views: 8765,
    content: '',
  },
];

export const homeFaqs = [
  {
    q: '亚洲在线是什么样的平台？',
    a: '亚洲在线是面向亚洲用户的一站式在线服务平台，汇聚亚洲各地优质资源与内容，涵盖娱乐影音、在线购物、旅游出行、科技数码、生活服务等多个领域，为用户提供便捷、安全、高效的在线体验。',
  },
  {
    q: '亚洲在线的服务覆盖哪些地区？',
    a: '亚洲在线的服务和内容覆盖东亚、东南亚、南亚、中亚等亚洲主要地区，包括中国、日本、韩国、新加坡、泰国、越南、印度等多个国家和地区，持续拓展更多亚洲市场。',
  },
  {
    q: '如何在亚洲在线上找到我需要的内容？',
    a: '您可以通过首页的分类导航浏览不同类别的内容，也可以使用搜索功能快速查找。我们按照娱乐、购物、旅游、科技、生活等类别对内容进行了精心整理，方便您快速定位感兴趣的信息。',
  },
  {
    q: '亚洲在线的内容是否免费？',
    a: '亚洲在线的大部分内容和服务均为免费提供。部分精选内容和高级服务可能需要订阅或付费，我们会在相关页面明确标注价格信息，确保透明公正。',
  },
  {
    q: '如何联系亚洲在线的客服团队？',
    a: '您可以通过关于我们页面的联系表单提交您的问题或建议，也可以发送邮件至 support@yazhouzaixian.com，我们的客服团队将在24小时内回复您的咨询。',
  },
  {
    q: '亚洲在线如何保障用户信息安全？',
    a: '亚洲在线严格遵守亚洲各国的数据保护法规，采用先进的加密技术和安全措施保护用户隐私。我们承诺不会将您的个人信息泄露给任何第三方，详细信息请参阅我们的隐私政策。',
  },
];

export const siteInfo = {
  name: '亚洲在线',
  tagline: '亚洲最全在线服务平台',
  description: '亚洲在线是面向亚洲用户的一站式在线服务平台，汇聚亚洲各地优质资源与内容，提供便捷、安全、高效的在线体验。无论您身处亚洲何地，亚洲在线都能满足您的多元需求。',
  email: 'support@yazhouzaixian.com',
  phone: '+86-400-888-8888',
  address: '中国上海市浦东新区陆家嘴金融贸易区世纪大道100号',
  founded: '2020',
  stats: {
    users: '500万+',
    articles: '10万+',
    countries: '30+',
    partners: '2000+',
  },
};